/**
 * @fileoverview Pipeline Analysis API Service
 * @description API calls for pipeline analysis feature
 */

import { apiClient } from '@/services';

const BASE_PATH = '/v1/pipeline';

export const pipelineAnalysisApi = {
  /**
   * Fetch Azure DevOps projects.
   * @returns {Promise<Array>} Array of project objects
   */
  fetchProjects: () => apiClient.get(`${BASE_PATH}/projects`),

  /**
   * Fetch pipelines for the selected project.
   * @param {string} projectId
   * @returns {Promise<Array>}
   */
  fetchPipelines: (projectId) =>
    apiClient.post(`${BASE_PATH}/pipelines`, {
      ProjectId: projectId,
    }),

  /**
   * Fetch pipeline runs for selected project and pipeline.
   * @param {string} projectId
   * @param {string|number} pipelineId
   * @returns {Promise<Array>}
   */
  fetchPipelineRuns: (projectId, pipelineId) =>
    apiClient.post(`${BASE_PATH}/pipeline-runs`, {
      ProjectId: projectId,
      PipelineId: pipelineId,
    }),

  /**
   * Fetch releases for selected project.
   * @param {string} projectId
   * @returns {Promise<Array>}
   */
  fetchReleases: (projectId) =>
    apiClient.get(`${BASE_PATH}/releases`, {
      ProjectId: projectId,
    }),

  /**
   * Fetch run details for selected build/run id.
   * Backend expects BuildId.
   * @param {string} projectId
   * @param {string|number} buildId
   * @returns {Promise<Array>}
   */
  fetchRunDetails: (projectId, buildId) =>
    apiClient.post(`${BASE_PATH}/run-details`, {
      ProjectId: projectId,
      BuildId: buildId,
    }),

  /**
   * Analyze failure error and stack trace.
   * @param {string} errorMessage
   * @param {string} stackTrace
   * @returns {Promise<any>}
   */
  analyzeFailure: (errorMessage, stackTrace) =>
    apiClient.post(`${BASE_PATH}/analyze`, {
      ErrorMessage: errorMessage,
      StackTrace: stackTrace,
    }),

  /**
   * Fetch project-wise savings report based on live pipeline/runs data.
   * @param {Object} params
   * @param {string} params.ProjectId
   * @param {number|string} params.MaxPipelines
   * @returns {Promise<Object>}
   */
  fetchProjectSavingsReport: (params = {}) =>
    apiClient.get(`${BASE_PATH}/project-savings-report`, params),

  fetchProjectSavingsProjects: () =>
    apiClient.get(`${BASE_PATH}/project-savings-report/projects`),

  createProjectSavingsReportJob: (params = {}) =>
    apiClient.post(`${BASE_PATH}/project-savings-report/jobs`, params),

  getProjectSavingsReportJob: (jobId) =>
    apiClient.get(`${BASE_PATH}/project-savings-report/jobs/${jobId}`),
};

export default pipelineAnalysisApi;
